import { type ComponentProps } from 'react';

export const BackIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 8.76923H14.625C17.0412 8.76923 19 10.8356 19 13.3846C19 15.9336 17.0412 18 14.625 18H8.5M5 8.76923L7.625 6M5 8.76923L7.625 11.5385"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
